import { ImageService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';
import * as IDavis from '@DavisDigital/interfaces';

class ModalImageFullscreenController {
  
    public image: IDavis.IImage; // '=' binding
    public imageWrapperSelector: string = '#fullscreenImageItemWrapper';
    public imageElement: any;
    public objImageZoom: any;
    private container: HTMLElement;
    private zoomSlider: HTMLInputElement;
    private zoomPercentage: HTMLElement;
    private scale: number = 1;
    private isDragging: boolean = false;
    private startX: number = 0;
    private startY: number = 0;
    private translateX: number = 0;
    private translateY: number = 0;
    private readonly panStep: number = 10;
    	public backgroundColor:string="#000000"; 	
	public contentModule;
	public contentModuleImage;
	public fade = true;

	public imageSelector = '#GalleryModalCenter .slick-active img';
	public images;
	public goTo;
	public loading = true;
	public originalWidth;
	public originalHeight;

	// meanings behind these bools is backwards to the name.
	// when hide... === true, then it's showing
	public hideImageCreditLine = true; 
	public hideImageNote = true; 
	public hideBookCreditLine = true;
	public hideLessonCaption = true;
	public hideLessonCreditLine = true;
	public hidePortfolioCaption = true;
	
	//property to hide footer for single image
	public hideFooter;
	
	public currentMarginLeft = 0;
	public currentMarginTop = 0;
	
	public showToolTip = true;
	public slickInitialized = false;
	public speed;
	public speedOptions = [
		{
			name: '5 sec',
			value: 5000
		},	
		{
			name: '10 sec',
			value: 10000
		},	
		{
			name: '15 sec',
			value: 15000
		},	
		{
			name: '20 sec',
			value: 20000
		},
		{
			name: '30 sec', 
			value: 30000
		}
	]
	
	public transitionSpeed = 300;
	
	public playing = false;
	
	public zoomValue; 
	public zoomOptions = [
		{
			name:"25%",
			value:.25
		},
		{
			name:"50%",
			value:.50
		},
		{
			name:"75%",
			value:.75
		},
		{
			name:"100%",
			value:1
		},
		{
			name:"125%",
			value:1.25
		},
		{
			name:"150%",
			value:1.50
		},
		{
			name:"175%",
			value:1.75
		},
		{
			name:"200%",
			value:2
		},
		{
			name:"225%",
			value:2.25
		},
		{
			name:"250%",
			value:2.50
		},
		{
			name:"275%",
			value:2.75
		},
		{
			name:"300%",
			value:3
		}
	];
	
	public zoomMovementPixelIncrement = 100;
	
	public zoomApplied = false;
	
    // @ngInject
    constructor(
        public ModalService,
        public $element,
        public $window,
        public $q: ng.IQService,
        public $scope: ng.IScope,
        public imageService: ImageService,
        public observerService: ObserverService,
        public $timeout : ng.ITimeoutService
	
		
    ) {}

    public $onInit = () => {
        this.speed = this.speedOptions[2];//15 seconds default
		
		if(this.image != null){
			this.speed = {
				value: 0
			};
			
			this.fade = false; 
		}
		
		this.zoomValue = this.zoomOptions[3];//100% default
		
		//set hideFooter property (in case not injected)
		this.hideFooter = this.hideFooter == true || false;
        
          let imageElementPromise = this.setImageElement();
       
        
        if (this.image === null) {
            this.ModalService.closeModals();
            return;
        }
    }
	public $onDestroy = () =>{
		this.destroySlick;
	}
	
	public reinitializeSlick = () =>{
		this.destroySlick();
		this.initializeSlick();
	}
	    public decodeImage = (): ng.IPromise<any> => {
        return this.$q((resolve: any, reject: any) => {
            this.imageElement
                .decode()
                .then(() => {
                    resolve(this.imageElement);
                })
                .catch((encodingError: any) => {
                    reject({
                        message: 'Image encoding error',
                        error: encodingError
                    });
                });
        });
    }

	public initializeSlick = () =>{
		this.loading = true;
		
		//HACK force digest otherwise $('.modal-gallery-slider') is undefined even though this is called from the link function
		this.$timeout(()=>{
			
			$('.modal-gallery-slider').on('init', (event, slick) => {
				
				
				//HACK force digest otherwise $('.modal-gallery-slider') is undefined
				this.$timeout(()=>{
					
					if(this.slickInitialized) return;
					
					this.slickInitialized = true;
					
					if(this.contentModuleImage != null && this.contentModuleImage.sortOrder != null){
						
						//reinit hack to get image to display https://stackoverflow.com/questions/48254835/slick-slider-width-0-on-initial-page-load
						$('.modal-gallery-slider').slick('unslick').slick('reinit')
						.slick({
						    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-chevron-left"></i></button>', 
						    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-chevron-right"></i></button>',
							infinite: true,
							autoplay: false,
							autoplaySpeed: this.speed.value,
							pauseOnFocus: false,
							pauseOnHover: false,
							fade: this.fade,
							speed: 300,
							lazyLoad: 'ondemand'
						})
						.slick('slickGoTo', this.contentModuleImage.sortOrder - 1);
						
					} else if(this.image != null){
						
						//reinit hack to get image to display https://stackoverflow.com/questions/48254835/slick-slider-width-0-on-initial-page-load
						$('.modal-gallery-slider').slick('unslick').slick('reinit')
						.slick({	
						  	infinite: false,
							autoplay: false,
							autoplaySpeed: this.speed.value,
							pauseOnFocus: false,
							pauseOnHover: false,
							fade: this.fade,
							speed: 300,
							lazyLoad: 'ondemand'
						})
						.slick('slickGoTo', 0);
						
					} else {
						//reinit hack to get image to display https://stackoverflow.com/questions/48254835/slick-slider-width-0-on-initial-page-load
						$('.modal-gallery-slider').slick('unslick').slick('reinit')
						.slick({	
						   
							infinite: true,
							autoplay: false,
							autoplaySpeed: this.speed.value,
							pauseOnFocus: false,
							pauseOnHover: false,
							fade: this.fade,
							speed: 300,
							lazyLoad: 'ondemand'
						})
						.slick('slickGoTo', this.goTo || 0);
						
						this.playing = true;
					}
					
					$('.modal-gallery-slider').on('beforeChange', (event, slick, currentSlide)=>{
						console.log('beforeChange', event, slick, currentSlide);
						//reset zoom to zero on change
						this.resetZoom();

					});
					
					this.loading = false;
				});
			});

			$('.modal-gallery-slider').slick({
			
				infinite: false,
				autoplay: false,
				autoplaySpeed: this.speed.value,
				pauseOnFocus: false,
				pauseOnHover: false,
				fade: this.fade,
				speed: this.transitionSpeed,
				lazyLoad: 'ondemand',
			});
		});
	}
	// meanings behind these bools is backwards to the name.
	// when hide... === true, then it's showing
	public hideCreditLineFor=(slideShowType)=>{
		switch (slideShowType) {
			case 'image':
				this.hideImageCreditLine = false;
				break;
			case 'imageNote':
				this.hideImageNote = false;
				break;
			case 'book':
				this.hideBookCreditLine = false;
				break;
			case 'lessonCaption':
				this.hideLessonCaption = false;
				break;
			case 'lesson':
				this.hideLessonCreditLine = false;
				break;
			case 'portfolio':
				this.hidePortfolioCaption = false;
				break;
		}
	}
	
	// meanings behind these bools is backwards to the name.
	// when hide... === true, then it's showing
	public showCreditLineFor=(slideShowType)=>{
		switch (slideShowType) {
			case 'image':
				this.hideImageCreditLine = true;
				break;
			case 'imageNote':
				this.hideImageNote = true;
				break;
			case 'book':
				this.hideBookCreditLine = true;
				break;
			case 'lessonCaption':
				this.hideLessonCaption = true;
				break;
			case 'lesson':
				this.hideLessonCreditLine = true;
				break;
			case 'portfolio':
				this.hidePortfolioCaption = true;
				break;
		}
	}
	
	
	public destroySlick = () =>{
		$('.modal-gallery-slider').slick('unslick');
	}
	
	public resetZoom = () =>{
		
		if(!this.zoomApplied) return;
		
		this.zoomApplied = false;
		
		$('.modal-gallery-slider').slick('slickSetOption', 'accessibility', true);
		
		var activeImage = $(this.imageSelector);
		
		activeImage.css('display', 'none');
		activeImage.css('max-width', '100%');
		activeImage.css('max-height', 'calc(100vh - 96px)');
		activeImage.width(this.originalWidth); 
		activeImage.height(this.originalHeight);
		
		this.originalWidth = null;
		this.originalHeight = null;
		this.currentMarginLeft = 0;
		this.currentMarginTop = 0;
		
		activeImage.css('margin-top', this.currentMarginTop + 'px'); 	
		//activeImage.css('margin-left', this.currentMarginLeft + 'px');
		
		//HACK force digest
		this.$timeout(()=>{
			this.zoomValue = this.zoomOptions[3];
		});
		
		this.$timeout(()=>{
			activeImage.css('display', 'block');
		},this.transitionSpeed)
	}
	
	public togglePlaying = () =>{
		this.playing = !this.playing;
		
		if(this.playing){
			$('.modal-gallery-slider').slick('slickPlay');
		} else {
			$('.modal-gallery-slider').slick('slickPause');
		}
	}
	
	public back = () =>{
		this.resetZoom();
		$('.modal-gallery-slider').slick('slickPrev');
	}
	
	public forward = () =>{
		this.resetZoom();
		$('.modal-gallery-slider').slick('slickNext');
	}
	
	public zoom = (currentZoomLevel=1) =>{
		
		this.zoomApplied = true;
		
		//set accessability to false so arrow keys can be used for navigation
		$('.modal-gallery-slider').slick('slickSetOption', 'accessibility', false);
		// NOTE: We intentionally do NOT move focus to '#GalleryModalCenter' here.
		// Doing so stole focus away from the activated zoom control, causing the
		// next Tab press to jump to the Close button and skip the remaining
		// controls (WCAG 2.4.3 Focus Order). Arrow-key panning still works
		// because keydown events bubble from the focused control up to the
		// container's ng-keydown handler (updateZoom).
        
        var viewportHeight = $('.slick-active').height();
        var viewportWidth = $('.slick-active').width();
		
		var activeImage = $(this.imageSelector);

		var width = activeImage.width(); 
		var height = activeImage.height(); 

		if(!this.originalWidth) this.originalWidth = width; 
		if(!this.originalHeight) this.originalHeight = height; 

		width = this.originalWidth * this.zoomValue.value;
		height = this.originalHeight * this.zoomValue.value;
		
		if(width > viewportWidth){
			activeImage.css('max-width', 'none');
		} else {
			activeImage.css('max-width', '100%');
		}
		
		if(height > viewportHeight){
			activeImage.css('max-height', 'none');
		} else {
			activeImage.css('max-height', 'calc(100vh - 96px)');
		}

		activeImage.width(width);
		activeImage.height(height);
	}
	
	public incrementZoom = () =>{
		
		this.zoomApplied = true;
		
		var currentZoom = this.zoomValue.value;
		
		for(var i=0; i<this.zoomOptions.length; i++){
			if(this.zoomValue.value == this.zoomOptions[i].value){
				if(i+1 < this.zoomOptions.length){
					this.zoomValue = this.zoomOptions[i+1];
					break;
				}
			}
		}
		this.zoom(currentZoom);
	}
	
	public decrementZoom = () =>{
		
		this.zoomApplied = true;
		
		var currentZoom = this.zoomValue.value;
		
		for(var i=0; i<this.zoomOptions.length; i++){
			if(this.zoomValue.value == this.zoomOptions[i].value){
				if(i-1 >= 0){
					this.zoomValue = this.zoomOptions[i-1];
					break;
				}
			}
		}
		this.zoom(currentZoom);
	}
	
	public updateBackgroundColor = (color) =>{
		this.backgroundColor = color
	}
	
	public updateSpeed = () =>{
		$('.modal-gallery-slider').slick('slickSetOption', 'autoplaySpeed', this.speed.value, true);
	}
	
	public updateZoom = (event) =>{
		console.log('event', event);
		if(!this.originalHeight || !this.originalWidth) return; 
		
		var activeImage = $(this.imageSelector);
		
		switch(event.originalEvent.keyCode){
			//left
			case 37: 
				if(Math.abs(this.currentMarginLeft + this.zoomMovementPixelIncrement) < (activeImage.width() / 1.25)){
					this.currentMarginLeft += this.zoomMovementPixelIncrement;
				}
				break; 
				
			//up
			case 38: 
				if(Math.abs(this.currentMarginTop + this.zoomMovementPixelIncrement) < (activeImage.height() / 1.25)){
					this.currentMarginTop += this.zoomMovementPixelIncrement;
				}
				break; 

			//right
			case 39: 
				if(Math.abs(this.currentMarginLeft - this.zoomMovementPixelIncrement) < (activeImage.width() / 1.25)){
					this.currentMarginLeft -= this.zoomMovementPixelIncrement;
				}
				break; 

			//down
			case 40: 
				if(Math.abs(this.currentMarginTop - this.zoomMovementPixelIncrement) < (activeImage.height() / 1.25)){
					this.currentMarginTop -= this.zoomMovementPixelIncrement;
				}
				break; 
		}

		activeImage.css('margin-top', this.currentMarginTop + 'px'); 	
		activeImage.css('margin-left', this.currentMarginLeft + 'px');
	}
	
	public close = () =>{
		this.destroySlick();
		this.ModalService.closeModals();
		// Focus is returned to the element that opened the dialog by the
		// image controller via the modal's `close` promise (WCAG 2.4.3).
	}


   public setImageElement = (): ng.IPromise<any> => {
    return this.$q((resolve: any, reject: any) => {

    	this.container = document.querySelector('.image-container') as HTMLElement;
        this.zoomSlider = document.getElementById('zoom-slider') as HTMLInputElement;
        this.zoomPercentage = document.getElementById('zoom-percentage') as HTMLElement; 
        // Find the image container and zoomable image element
        let imageContainer = document.querySelector('.slide-img');
        let imageElement: HTMLImageElement | null = imageContainer ? imageContainer.querySelector('.zoomable-image') : null;
		console.log(imageElement);
        if (imageElement) {
            console.log(imageElement);
            // Set the image source and alt attributes
            imageElement.setAttribute('src', this.image.s3PathToImageFile);
            imageElement.setAttribute('alt', this.image.imageName);

            // Store the image element in the class variable
            this.imageElement = imageElement;

            // Resolve the promise with the image element
            resolve(imageElement);
        } else {
            // Reject if the image element is not found
            reject({
                message: 'Image element is not valid'
            });
        }
    });
}


}

export class ModalImageFullscreen {
    
    public restrict: string = 'EA';
	public scope: boolean = true;
	
	public bindToController: any = {
		contentModule : '=',
		contentModuleImage : '=?',
		image: '=?',
		images : '=?',
		goTo: '=?',
		hideFooter: '=?',
		hideCraditLine:'=?',
		hideImageNote:"=?"
	}

   
    public controller: any = ModalImageFullscreenController;
    public controllerAs: string = 'modalImageFullscreen';
    public templateUrl: string = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/modal-image-fullscreen.html';
   

	
	//@ngInject
    constructor(private $timeout){
    }
	
    public static Factory() {
        	var directive = ($timeout) => new this($timeout);
		directive.$inject = ['$timeout'];
		return directive;
    }
    
    public link:ng.IDirectiveLinkFn = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs:ng.IAttributes) =>{
		scope.modalImageFullscreen.initializeSlick();
		
		// Focus management: move focus into modal when it opens
		this.$timeout(() => {
			const modalEl = element.find('#GalleryModalCenter');
			if (modalEl.length) {
				// Focus the close button as the first interactive element
				const closeBtn = modalEl.find('button.close').first();
				if (closeBtn.length) {
					closeBtn[0].focus();
				} else {
					// Fallback: focus the modal container itself
					modalEl[0].focus();
				}
			}
			
			// Focus trap: keep focus inside the modal
			modalEl.on('keydown', (event) => {
				if (event.key === 'Tab') {
					const focusableElements = modalEl.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
					const firstFocusable = focusableElements.first();
					const lastFocusable = focusableElements.last();
					
					if (event.shiftKey) {
						// Shift+Tab: if on first element, wrap to last
						if (document.activeElement === firstFocusable[0]) {
							event.preventDefault();
							lastFocusable[0].focus();
						}
					} else {
						// Tab: if on last element, wrap to first
						if (document.activeElement === lastFocusable[0]) {
							event.preventDefault();
							firstFocusable[0].focus();
						}
					}
				}
				
				// ESC to close modal
				if (event.key === 'Escape') {
					scope.modalImageFullscreen.close();
					scope.$apply();
				}
			});
		}, 500); // Delay to allow slick initialization
    }
}